import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/CartService';
import CartRepository from '~repositories/CartRepository/CartRepository';
import { IUpdatePayload } from '~api/CartAPI/ICartApiSdk';
import CartSidebar from '~domain/entities/CartSidebar/CartSidebar';
import { events } from 'elc-service-bus';
import { eventEmitter } from '~sharedComponents/EventAdapter';

export default class UpdateCartUseCase {
    private readonly skus: string[];
    private readonly quantity: number;
    private cartRepository: CartRepository;
    private cartSidebar: CartSidebar;

    constructor({ skus, quantity }: IUpdatePayload) {
        this.skus = skus;
        this.quantity = quantity;
        this.cartRepository = diContainer.get(serviceNames.cartRepository);
        this.cartSidebar = diContainer.get(serviceNames.cartSidebar);
    }

    public execute = () => {
        try {
            this.cartSidebar.setLoading(true);
            const res = this.cartRepository.updateItem({
                skus: this.skus,
                quantity: this.quantity
            });
            const cartItems = this.cartRepository.cart.cartItems;
            const currentCartItem = cartItems.find((item) => item.skuId === this.skus[0]);
            const updateCartItem =
                currentCartItem && currentCartItem.quantity > this.quantity
                    ? 'cart.removeFromCart'
                    : 'cart.addToCart';
            window.dispatchEvent(
                new CustomEvent(updateCartItem, { detail: { product_sku: currentCartItem?.skuId } })
            );
            eventEmitter(events.CART_UPDATED, { newDisplayState: true, newVisibility: true });

            return res;
        } finally {
            this.cartSidebar.setLoading(false);
        }
    };
}
